/**
 * @fileoverview AR-924 — 40px thumbnail of a staged item: image preview or a glyph per kind.
 */

import { Box, ThemeIcon } from '@mantine/core'
import { IconFile, IconLink, IconMusic, IconVideo } from '@tabler/icons-react'
import type { StagedItem } from './stagedItems'

const THUMB_SIZE = 40
const GLYPH_ICON_SIZE = 18
const PREVIEW_STYLE = { width: '100%', height: '100%', objectFit: 'cover' as const }

function Glyph({ item }: { item: StagedItem }) {
  if (item.kind === 'link') return <IconLink size={GLYPH_ICON_SIZE} />
  if (item.fileKind === 'video') return <IconVideo size={GLYPH_ICON_SIZE} />
  if (item.fileKind === 'audio') return <IconMusic size={GLYPH_ICON_SIZE} />
  return <IconFile size={GLYPH_ICON_SIZE} />
}

export function StagedThumb({ item }: { item: StagedItem }) {
  return (
    <Box
      sx={theme => ({
        width: THUMB_SIZE, height: THUMB_SIZE, borderRadius: theme.radius.sm, overflow: 'hidden', flexShrink: 0,
      })}
    >
      {item.preview
        ? <img src={item.preview} alt="" style={PREVIEW_STYLE} />
        : <ThemeIcon variant="light" size={THUMB_SIZE} radius="sm"><Glyph item={item} /></ThemeIcon>}
    </Box>
  )
}
